import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/immatricolazioni.vue";
//import store from '../store/index.js'
import Login from "../views/Login.vue";
import LoginOperatore from "../views/LoginOperatore.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/immatricolazioni",
    name: "Home",
    component: Home,
  },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/segreteria",
    name: "LoginOperatore",
    component: LoginOperatore,
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
